import { render } from "./laboratory.vue?vue&type=template&id=50d48f6e&scoped=true"
import script from "./laboratory.vue?vue&type=script&lang=js"
export * from "./laboratory.vue?vue&type=script&lang=js"

import "./laboratory.vue?vue&type=style&index=0&id=50d48f6e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-50d48f6e"

export default script